<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path
      d="m843-28-92-92H180q-25 0-42.5-17.5T120-180v-571l-82-82 43-43L886-71l-43 43ZM240-300h331l-85-86-46 55-80-109-120 140Zm600 98L202-840h578q25 0 42.5 17.5T840-780v578Z"
    />
  </svg>
</template>
